import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { setListOptions } from '@/features/domain/lists/actions'
import { selectDevicesListOptions } from '@/features/domain/lists'
import { useAppDispatch } from '@/store'

/**
 * Set the search' query of the list options.
 */
export function useSetQuery() {
  const listOptions = useSelector(selectDevicesListOptions)
  const dispatch = useAppDispatch()

  return useCallback(
    async (newValue: string) => {
      const request = await dispatch(
        setListOptions({
          category: 'devices',
          options: { ...listOptions, search: { ...listOptions.search, query: newValue } },
        }),
      )
      return setListOptions.fulfilled.match(request)
    },
    [dispatch, listOptions],
  )
}
